<template>
    <div>
        <div>
            <div class='plugins-tips'>
                <el-row>
                    <el-col :span='22'>
                        <el-form ref='queryForm' :inline='true' size='small'>
                            <el-form-item style='margin-bottom: 0'>
                                <el-select v-model='query.projectName'
                                           clearable
                                           size='mini'
                                           filterable placeholder='项目名称' @change='current($event)'
                                           value-key='projectId'
                                           class='handle-select mr10'>
                                    <el-option v-for='val in projects' :key='val.id' :value='val.name'
                                               :label='val.cnName'></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label='渠道'>
                                <el-input v-model='query.channel' size='mini' placeholder='请输入查询渠道(回车搜索)'
                                          @blur='current' @keyup.enter.native='current' />
                            </el-form-item>
                            <el-form-item label='商品id'>
                                <el-input v-model='query.productId' size='mini' placeholder='请输入商品id(回车搜索)'
                                          @blur='current' @keyup.enter.native='current' />
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-button v-if='multipleSelection.length !== 0' type='success' size='mini'
                                           style='float:right' @click='showMultipleList'>批量操作
                                </el-button>
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-button v-if='multipleSelection.length !== 0' type='primary' size='mini'
                                           style='float:right' @click='handleBatchCopy'>批量拷贝
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span='2'>
                        <el-row class='mb8'>
                            <el-col :span='8'>
                                <el-button
                                    icon='el-icon-refresh'
                                    plain
                                    size='mini'
                                    type='primary'
                                    @click='resetQuery'
                                >刷新
                                </el-button>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
            
            <el-table @selection-change="handleSelectionChange" :data="user.tableData" @row-click="rowNoticeClick"
                :header-cell-style="{ 'text-align': 'center' }" v-loading="user.loading" stripe>
                <el-table-column type='selection' fixed width='55'>
                </el-table-column>
                <el-table-column prop='id' fixed width='150' label='Id' align='center'></el-table-column>
                <el-table-column prop='productId' width='200' label='商品Id' align='center'></el-table-column>
                <el-table-column prop='name' label='商品名称' width='150' align='center'></el-table-column>
                <el-table-column prop='price' label='商品金额' align='center'></el-table-column>
                <el-table-column prop='produceCount' label='发放数量' align='center'></el-table-column>
                
                <el-table-column prop='projectName' width='200' label='商品状态' align='center'>
                    <template slot-scope="scope">
                        <el-switch
                            v-model='scope.row.state'
                            active-text='上架'
                            :active-value='1'
                            :inactive-value='0'
                            @change='modifyProduceState(scope.row)'
                            inactive-text='下架'>
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop='limitationType' label='是否限购' align='center' width='120'>
                    <template slot-scope="scope">
                        <el-tag :type='scope.row.limitBuyStatus === true ? "danger" : ""'>
                            {{ scope.row.limitBuyStatus === true ? `限购${scope.row.limitCount || 1}件` : '不限购' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop='channels' label='渠道' width='200' align='center'>
                    <template slot-scope='scope'>
                        <template v-if='getChannelList(scope.row.channels).length === 0'>
                            <el-tag type='info' size='mini'>全渠道</el-tag>
                        </template>
                        <template v-else>
                            <el-tag type='success' size='mini' style='margin: 2px;'
                                    v-for='(channel, index) in getChannelList(scope.row.channels).slice(0, 2)'
                                    :key='index'>
                                {{ channel }}
                            </el-tag>
                            <el-tooltip v-if='getChannelList(scope.row.channels).length > 2' placement='top'>
                                <div slot='content'>
                                    <span v-for='(channel, index) in getChannelList(scope.row.channels)' :key='index'>
                                        {{ channel }}<br v-if='index < getChannelList(scope.row.channels).length - 1' />
                                    </span>
                                </div>
                                <el-tag type='warning' size='mini' style='margin: 2px; cursor: pointer;'>
                                    +{{ getChannelList(scope.row.channels).length - 2 }}
                                </el-tag>
                            </el-tooltip>
                        </template>
                    </template>
                </el-table-column>
                
                <el-table-column prop='discount' label='商品折扣' align='center'>
                    <template slot-scope='scope'>
                        <el-tag type='success'>{{ scope.row.discount }}%</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop='priceDiscount' label='商品折扣价' align='center'></el-table-column>
                <el-table-column prop='description' label='商品描述' width='200' show-overflow-tooltip
                                 align='center'></el-table-column>
                <el-table-column prop='type' label='道具类型' align='center'>
                    <template slot-scope='scope'>
                        <el-tag v-if="scope.row.type == '0'">普通道具</el-tag>
                        <el-tag v-if="scope.row.type == '1'">买断道具</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop='startTime' label='排序值' width='120' align='center'>
                    <template slot-scope='scope'>
                        <el-input
                            v-model='scope.row.productOrder'
                            size='mini'
                            style='max-width: 7rem;'
                            @keyup.enter.native='updateProductOrder(scope.row, $event)'
                        >
                        </el-input>
                    </template>
                </el-table-column>
                <el-table-column prop='projectName' label='所属项目' width='150' align='center'></el-table-column>
                <!--<el-table-column prop='startTime' label='定时生效时间' align='center'>-->
                <!--    <template slot-scope="scope">-->
                <!--        <span v-if="scope.row.startTime != null">{{ scope.row.startTime }}</span>-->
                <!--        <span v-if="scope.row.startTime == null">暂无</span>-->
                <!--    </template>-->
                <!--</el-table-column>-->
                <!--<el-table-column prop='endTime' label='定时结束时间' align='center'>-->
                <!--    <template slot-scope="scope">-->
                <!--        <span v-if="scope.row.endTime != null">{{ scope.row.endTime }}</span>-->
                <!--        <span v-if="scope.row.endTime == null">暂无</span>-->
                <!--    </template>-->
                <!--</el-table-column>-->
                <el-table-column prop='createTime' width='150' label='创建时间' align='center'></el-table-column>
                
                <el-table-column fixed='right' align='center' width='200' class-name='small-padding fixed-width'
                                 label='操作'>
                    <template slot-scope='scope'>
                        <el-button icon='el-icon-edit'
                                   size='mini'
                                   type='text'
                                   @click="showEditDialog(scope.row.id, scope.row.name, scope.row.description, scope.row.price,
                            scope.row.discount, scope.row.type, scope.row.projectName, scope.row.produceCount, scope.row.state, scope.row.additionalConfig, scope.row)">
                            编辑
                        </el-button>
                        <el-button
                            icon='el-icon-delete'
                            size='mini'
                            style='color: #F56C6C'
                            type='text'
                            @click='handleDelete(scope.row)'
                        >删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination background layout='sizes, total, prev, pager, next'
                               :current-page='user.pageIndex'
                               :page-size='user.pageSize' :total='user.pageTotal'
                               :page-sizes='[15, 30, 45, 60, 75, 100]'
                               @size-change='handleSizeChange'
                               @current-change='handleUserPageChange'></el-pagination>
            </div>
        </div>
        <!-- 修改用户的对话框 -->
        <el-dialog title="修改信息" :visible.sync="editDialogVisible" width="50%">
            <el-form :model="editForm" label-width="100px">
                <el-form-item label="商品名称">
                    <el-input size='mini' v-model='editForm.name'></el-input>
                </el-form-item>
                <el-form-item label='商品id'>
                    <el-input size='mini' v-model='editForm.productId'></el-input>
                </el-form-item>
                <el-form-item label='所属项目'>
                    <el-select filterable size='mini' v-model='editForm.projectName'
                               placeholder='项目名'>
                        <el-option
                            v-for='item in projects'
                            :key='item.id'
                            :label='item.cnName'
                            :value='item.name'>
                        </el-option>
                    </el-select>
                    <!--<el-input v-model="editForm.projectName"></el-input>-->
                </el-form-item>
                <el-form-item label="商品价格">
                    <el-input size='mini' v-model='editForm.price'></el-input>
                </el-form-item>
                <el-form-item label="商品折扣">
                    <el-input size='mini' placeholder='100是原价，90是九折' v-model='editForm.discount'></el-input>
                </el-form-item>
                <el-form-item label="商品类型">
                    <el-select size='mini' v-model='editForm.type' placeholder='商品类型' class='handle-select mr10'>
                        <el-option v-for="item in produceType" :label="item.label" :key="item.value" :value="item.value"/>
                    </el-select>
                </el-form-item>
                <el-form-item label='购买发放数量'>
                    <el-input size='mini' placeholder='如用户购买后, 向用户发放1000金币'
                              v-model='editForm.produceCount'></el-input>
                </el-form-item>
                <el-form-item label='商品上/下架'>
                    <el-switch
                        v-model='editForm.state'
                        active-text='上架'
                        :active-value='1'
                        :inactive-value='0'
                        inactive-text='下架'>
                    </el-switch>
                </el-form-item>
                
                <br>
                <el-divider content-position='center'>其他属性</el-divider>
                <el-form-item label='登录购买限制' prop='produce'>
                    <el-switch
                        v-model='editForm.loginLimit'
                        active-text='需要登录'
                        inactive-text='不需要登录'>
                    </el-switch>
                </el-form-item>
                <el-form-item label='商品限购'>
                    <el-switch
                        v-model='editForm.limitBuyStatus'
                        active-text='开启'
                        :active-value='true'
                        :inactive-value='false'
                        inactive-text='取消'>
                    </el-switch>
                    
                    <div v-if='editForm.limitBuyStatus'>
                        <el-alert
                            :title="getLimitDesc(editForm)"
                            type="success" style='margin-bottom: 1rem;margin-top: 1rem;' :closable='false'>
                        </el-alert>
                        <el-form-item label='限购数量'>
                            <el-input size='mini' type='text' placeholder='每个用户限购数量(<=0不限制)'
                                      v-model='editForm.limitCount'></el-input>
                        </el-form-item>
                        <el-form-item label='限购周期类型'>
                            <el-select size='mini' v-model='editForm.purchaseCooldownPeriodType' placeholder='周期类型' class='handle-select mr10'>
                                <el-option v-for="item in purchaseCooldownPeriodTypeOption" :label="item.label" :key="item.value" :value="item.value"/>
                            </el-select>
                        </el-form-item>
                        <el-form-item label='限购周期值'>
                            <el-input size='mini' type='text'
                                      :placeholder='`在xxx周期内可购买${editForm.limitCount || 1}个商品`'
                                      v-model='editForm.purchaseCooldownPeriod'></el-input>
                        </el-form-item>
                    </div>
                </el-form-item>
                <el-form-item label='上架平台列表'>
                    <div>
                        <el-tag
                            :key='tag'
                            v-for='tag in productChannels'
                            closable
                            size='mini'
                            style='margin-right: .5rem;'
                            :disable-transitions='false'
                            @close='handleClose(tag)'>
                            {{ tag }}
                        </el-tag>
                        <el-input
                            class='input-new-tag'
                            v-if='productChannelInputVisible'
                            v-model='productInputChannel'
                            ref='saveTagInput'
                            size='mini'
                            placeholder='输入渠道(多个渠道使用空格分隔)'
                            style='max-width: 20rem;'
                            @keyup.enter.native='handleInputConfirm'
                            @blur='handleInputConfirm'
                        >
                        </el-input>
                        <el-button v-else class='button-new-tag' size='mini' @click='showInput'>+ 新渠道(默认全渠道)
                        </el-button>
                    </div>
                </el-form-item>
                <el-form-item label='商品排序值'>
                    <el-input
                        placeholder='客户端可使用该值对商品列表进行自定义排序'
                        class='input-new-tag'
                        v-model='editForm.productOrder'
                        size='mini'
                    >
                    </el-input>
                </el-form-item>
                <el-form-item label='商品描述'>
                    <el-input placeholder='商品描述 非必须' size='mini' v-model='editForm.description'></el-input>
                </el-form-item>
                <el-form-item label='客户端元数据'>
                    <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder='非必须 如需在商品中存储客户端自定义数据, 可在这里设置(推荐JSON格式)' size='mini' v-model='editForm.metadata'></el-input>
                </el-form-item>
                
                <br>
                <el-divider content-position='center'>云存储配置(非必须)</el-divider>
                <product-shipping-config @submitConfig='handleSubmitConfig' :project-name='editForm.projectName'
                                           :project-info-list='projects' :additional-config='additionalConfig' />
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click='handleCloseEditDialog()'>取 消</el-button>
                <el-button type="primary" @click="editAntiProjectData">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="批量修改信息" :visible.sync="editMultipleDialogVisible" width="60%" :close-on-click-modal="false">
            <el-form :model="editMultipleForm" ref="editMultipleFormRef" label-width="100px">
                <h4 style='margin-bottom: 20px;'>已选中 {{ this.multipleSelection.length }} 条数据</h4>
                
                <el-form-item label='商品折扣'>
                    <el-row type='flex' justify='space-between' align='middle'>
                        <el-col :span='20'>
                            <el-input size='mini' v-model='editMultipleForm.discount' style='width:200px'></el-input>
                        </el-col>
                        <el-col :span='4' style='text-align: right;'>
                            <el-button size='mini' type='primary' @click="editMultipleAntiProjectData('discount')">修
                                改
                            </el-button>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-divider />
                
                <el-form-item label='商品上/下架'>
                    <el-row type='flex' justify='space-between' align='middle'>
                        <el-col :span='20'>
                            <el-switch
                                v-model='editMultipleForm.state'
                                active-text='上架'
                                :active-value='1'
                                :inactive-value='0'
                                inactive-text='下架'>
                            </el-switch>
                        </el-col>
                        <el-col :span='4' style='text-align: right;'>
                            <el-button size='mini' type='primary' @click="editMultipleAntiProjectData('state')">修 改
                            </el-button>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-divider />
                
                <el-form-item label='登录购买限制' prop='produce'>
                    <el-row type='flex' justify='space-between' align='middle'>
                        <el-col :span='20'>
                            <el-switch
                                v-model='editMultipleForm.loginLimit'
                                active-text='需要登录'
                                inactive-text='不需要登录'>
                            </el-switch>
                        </el-col>
                        <el-col :span='4' style='text-align: right;'>
                            <el-button size='mini' type='primary' @click="editMultipleAntiProjectData('loginLimit')">修
                                改
                            </el-button>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-divider />
                <el-form-item label='商品限购'>
                    <el-row type='flex' justify='space-between' align='middle'>
                        <el-col :span='20'>
                            <el-form-item label=''>
                                <el-switch
                                    v-model='editMultipleForm.limitBuyStatus'
                                    active-text='开启'
                                    :active-value='true'
                                    :inactive-value='false'
                                    inactive-text='取消'>
                                </el-switch>
                                
                                <div v-if='editMultipleForm.limitBuyStatus'>
                                    <el-alert
                                        :title="getLimitDesc(editMultipleForm)"
                                        type="success" style='margin-bottom: 1rem;margin-top: 1rem;' :closable='false'>
                                    </el-alert>
                                    <el-form-item label='限购数量'>
                                        <el-input size='mini' type='text' placeholder='每个用户限购数量(<=0不限制)'
                                                  v-model='editMultipleForm.limitCount'></el-input>
                                    </el-form-item>
                                    <el-form-item label='限购周期类型'>
                                        <el-select size='mini' v-model='editMultipleForm.purchaseCooldownPeriodType' placeholder='周期类型' class='handle-select mr10'>
                                            <el-option v-for="item in purchaseCooldownPeriodTypeOption" :label="item.label" :key="item.value" :value="item.value"/>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label='限购周期值'>
                                        <el-input size='mini' type='text'
                                                  :placeholder='`在xxx周期内可购买${editMultipleForm.limitCount || 1}个商品`'
                                                  v-model='editMultipleForm.purchaseCooldownPeriod'></el-input>
                                    </el-form-item>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span='4' style='text-align: right;'>
                            <el-button size='mini' type='primary' @click="editMultipleAntiProjectData('buyLimit')">修
                                改
                            </el-button>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-divider />
                <el-form-item label='上架平台列表'>
                    <el-row type='flex' justify='space-between' align='middle'>
                        <el-col :span='20'>
                            <el-tag
                                :key='tag'
                                v-for='tag in productChannels'
                                closable
                                size='mini'
                                style='margin-right: .5rem;'
                                :disable-transitions='false'
                                @close='handleClose(tag)'>
                                {{ tag }}
                            </el-tag>
                            <el-input
                                class='input-new-tag'
                                v-if='productChannelInputVisible'
                                v-model='productInputChannel'
                                ref='saveTagInput'
                                size='mini'
                                placeholder='输入渠道(多个渠道使用空格分隔)'
                                style='max-width: 20rem;'
                                @keyup.enter.native='handleInputConfirm'
                                @blur='handleInputConfirm'>
                            </el-input>
                            <el-button v-else class='button-new-tag' size='mini' @click='showInput'>+
                                新渠道(默认全渠道)
                            </el-button>
                        </el-col>
                        <el-col :span='4' style='text-align: right;'>
                            <el-button size='mini' type='primary' @click="editMultipleAntiProjectData('channels')">修
                                改
                            </el-button>
                        </el-col>
                    </el-row>
                </el-form-item>
                
                <el-divider content-position='center'>云存储配置(非必须)</el-divider>
                <el-form-item>
                    <el-row type='flex' justify='space-between' align='top'>
                        <el-col :span='20'>
                            <product-shipping-config @submitConfig='handleSubmitConfig'
                                                       :project-name='editMultipleForm.projectName'
                                                       :project-info-list='projects'
                                                       :additional-config='editForm.additionalConfig' />
                        </el-col>
                        <el-col :span='4' style='text-align: right;'>
                            <el-button size='mini' type='primary' @click="editMultipleAntiProjectData('cloudStorage')">修
                                改
                            </el-button>
                        </el-col>
                    </el-row>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editMultipleDialogVisible = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import {
    cancelTimingTask,
    cancelTimingTaskList,
    modifyProduce,
    multipleOperationProduce,
    selProduce
} from '@api/produce';
import { queryProjectInfoList } from '@/components/api/ProjectInfo';
import { productApi } from '@api/productApi';
import { message } from '@/utils/message';
import { deepCopy } from '@/utils/object';
import ProductShippingConfig from '@/components/component/product/ProductShippingConfig.vue';


export default {
    name: 'ProduceInfo',
    components: { ProductShippingConfig },
    data: function () {
        return {
            // 控制批量操作用户对话框的显示与隐藏，默认为隐藏
            editMultipleDialogVisible: false,
            // 批量操作集合
            multipleSelection: [
            ],
            //批量操作 对话框
            editMultipleForm: {
                discount: 100,
                state: 0,
                loginLimit: true,
                limitBuyStatus: false,
                limitCount: 1,
                projectName: undefined,
                purchaseCooldownPeriodType: undefined,
                purchaseCooldownPeriod: undefined
            },
            query: {
                noticeSearch: '',
                projectName: null, // 下拉框值
                deviceId: '',    // 搜索框
                channel: undefined,
                productId: undefined
            },
            user: {
                tableData: [],
                pageIndex: 1,
                pageSize: 10,
                pageTotal: 1,
                loading: false
            },
            projects: [], //下拉框集合
            // 控制修改用户对话框的显示与隐藏，默认为隐藏
            editDialogVisible: false,
            // 修改数据 对话框
            editForm: {
                id: "",
                name: '',
                description: '',
                price: '',
                type: '',
                projectName: "",
                discount: "",
                priceDiscount: "",
                delayTime: "",
                state: 0,
                endTime: "",
                startTime: "",
                projectData: "",
                multipleProjectData: "",
                produceCount: '',
                additionalConfig: undefined,
                loginLimit: undefined,
                productOrder: undefined,
                limitBuyStatus: undefined,
                limitCount: undefined,
                productId: undefined,
                metadata: undefined,
                purchaseCooldownPeriodType: undefined,
                purchaseCooldownPeriod: undefined
            },
            // 商品类型
            produceType: [
                {
                    label: '普通商品',
                    value: 0
                },
                {
                    label: '买断商品',
                    value: 1
                }
            ],
            additionalConfig: undefined,
            productChannels: [],
            productInputChannel: undefined,
            productChannelInputVisible: false,
            purchaseCooldownPeriodTypeOption: [
                {
                    label: '天',
                    value: 'DAY'
                },
                {
                    label: '周',
                    value: 'WEEK'
                },
                {
                    label: '月',
                    value: 'MONTH'
                },
                {
                    label: '年',
                    value: 'YEAR'
                },
                {
                    label: '无固定周期',
                    value: 'PERMANENT'
                }
                
            ]
        }
    },
    created() {
        this.initUserData()
        this.getProjectName()
        this.getDeviceInfoData(1, this.query.projectName, this.query.deviceId)
    },
    computed: {
        getChannelList() {
            return channels => {
                if (!channels) {
                    return [];
                }
                try {
                    return JSON.parse(channels);
                } catch (e) {
                    return [];
                }
            };
        },
        getLimitDesc() {
            return obj => {
                let buyCountDesc
                let purchaseTypeDesc
                if (!obj.limitCount || obj.limitCount <= 0) {
                    buyCountDesc = '无限'
                }else {
                    buyCountDesc = obj.limitCount
                }
                const map = {
                    DAY: '天',
                    WEEK: '周',
                    MONTH: '月',
                    YEAR: '年',
                    PERMANENT: ''
                }
                if (obj.purchaseCooldownPeriodType && obj.purchaseCooldownPeriodType !== 'PERMANENT') {
                    purchaseTypeDesc = `在${obj.purchaseCooldownPeriod || 1}${map[obj.purchaseCooldownPeriodType]}内`
                }else {
                    purchaseTypeDesc = '在任何时间内'
                }
                return `用户${purchaseTypeDesc}最多只能购买${buyCountDesc}个商品`
            }
        }
    },
    activated() {
        this.initUserData()
    },
    methods: {
        formatPurchaseCount(row, column, cellValue) {
            if (row.limitBuyStatus === true) {
                return row.limitCount < 0 ? '不限制' : `限购${row.limitCount}`;
            }
            return '不限制';
        },
        cancelTimingTaskListMethod() {
            this.$confirm('确定要执行该操作吗', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let list = [];
                this.multipleSelection.forEach((item, index) => {
                    list.push({
                        "id": item.id
                    });
                })
                cancelTimingTaskList(list).then(res => {
                    if (res.status === 200) {
                        // 修改成功, 更新表格
                        this.initUserData();
                        this.editMultipleDialogVisible = false;
                        this.editForm.multipleProjectData = "";
                        this.$message.success('调用成功')
                    } else {
                        this.$message.error('调用失败')
                    }
                })
            }).catch(() => {
                // 取消操作
            });
        },
        
        handleBatchCopy() {
            if (!this.multipleSelection.length) {
                return;
            }
            this.$confirm(`该操作将复制所选的${this.multipleSelection.length}个商品的所有数据, 渠道会修改为 'TEMP', 拷贝成功后, 可根据渠道TEMP进行查询和修改`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let list = deepCopy(this.multipleSelection);
                list.forEach(item => {
                    item.channels = '["TEMP"]';
                });
                productApi.batchInsert(list).then(result => {
                    if (result.code === 200) {
                        message.success('拷贝成功');
                        this.initUserData();
                    }
                });
            });
        },
        showMultipleList() {
            // 判断所选择的是否为同一个项目
            const names = this.multipleSelection.map(item => item.projectName);
            let uniqueChannels = [];
            let additionalConfig = '{}';
            try {
                uniqueChannels = [...new Set(this.multipleSelection.map(t => t.channels).filter(Boolean).flatMap(item => JSON.parse(item)))];
            } catch (e) {
            }
            
            try {
                additionalConfig = [
                    ...new Set(
                        this.multipleSelection
                            .map(t => t.additionalConfig)
                            .filter(Boolean) // 去掉空值
                    )
                ][0];
            } catch (e) {
            }
            
            const uniqueNames = [...new Set(names)];
            if (uniqueNames.length > 1) {
                message.error(`批量操作只能选择同一项目, 当前选择的商品列表包含${uniqueNames}`);
                return;
            }
            
            this.editMultipleForm = {
                discount: 100,
                state: 0,
                loginLimit: true,
                limitBuyStatus: false,
                limitCount: 1,
                projectName: uniqueNames[0]
            };
            this.productInputChannel = undefined;
            this.editMultipleDialogVisible = true
            this.productChannelInputVisible = false;
            this.productChannels = uniqueChannels;
            this.editForm.additionalConfig = additionalConfig;
        },
        editMultipleAntiProjectData(type) {
            if (this.multipleSelection.length <= 0) {
                message.info('没有选中数据');
                return
            }
            let list = this.multipleSelection.map(item => {
                return { id: item.id };
            });
            
            if (type === 'discount') {
                list.forEach(item => {
                    item.discount = this.editMultipleForm.discount;
                });
            } else if (type === 'state') {
                list.forEach(item => {
                    item.state = this.editMultipleForm.state;
                });
            } else if (type === 'loginLimit') {
                list.forEach(item => {
                    item.loginLimit = this.editMultipleForm.loginLimit;
                });
            } else if (type === 'buyLimit') {
                list.forEach(item => {
                    item.limitBuyStatus = this.editMultipleForm.limitBuyStatus;
                    item.limitCount = this.editMultipleForm.limitCount;
                    item.purchaseCooldownPeriodType = this.editMultipleForm.purchaseCooldownPeriodType;
                    item.purchaseCooldownPeriod = this.editMultipleForm.purchaseCooldownPeriod;
                });
            } else if (type === 'channels') {
                list.forEach(item => {
                    item.channels = JSON.stringify(this.productChannels);
                });
            } else if (type === 'cloudStorage') {
                list.forEach(item => {
                    if (this.editForm.additionalConfig) {
                        item.additionalConfig = this.editForm.additionalConfig;
                    } else {
                        item.additionalConfig = '{}';
                    }
                });
            } else {
                message.error('未支持的类型操作');
                return;
            }
            
            this.$confirm(`确认批量修改${this.multipleSelection.length}条数据么?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                multipleOperationProduce(list).then(res => {
                    if (res.status === 200) {
                        // 修改成功, 更新表格
                        this.initUserData();
                        this.editMultipleDialogVisible = false;
                        this.$message.success('调用成功');
                    } else {
                        this.$message.error('调用失败');
                    }
                });
            });
        },

        cancelTimingTaskMethod(id) {
            this.$confirm('确定要执行该操作吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'

            }).then(() => {
                let params = { "id": id };
                cancelTimingTask(params).then(res => {
                    if (res.status === 200) {
                        // 修改成功, 更新表格
                        this.initUserData()
                        this.editDialogVisible = false
                        this.$message.success('取消成功')
                    } else {
                        this.$message.error('取消失败')
                    }
                })
            }).catch(() => {
                // 取消操作
            });
        },
        modifyProduceState(value) {
            this.$confirm('确定要执行上/下架操作吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                modifyProduce(value).then(res => {
                    if (res.status === 200) {
                        // 修改成功, 更新表格
                        this.initUserData()
                        this.$message.success('修改成功')
                    } else {
                        this.$message.error('修改失败')
                    }
                })
            }).catch(() => {
                if (value.state === 1) {
                    value.state = 0;
                } else {
                    value.state = 1;
                }
            });
        },

        // 修改表单提交
        editAntiProjectData() {
            this.editForm.startTime = this.editForm.delayTime[0];
            this.editForm.endTime = this.editForm.delayTime[1];
            this.editForm.priceDiscount = parseFloat((this.editForm.discount * 0.01 * this.editForm.price)).toFixed(2);
            
            try {
                this.editForm.channels = JSON.stringify((this.productChannels));
            } catch (e) {
            }
            
            let params = JSON.stringify(this.editForm)
            modifyProduce(params).then(res => {
                if (res.status === 200) {
                    // 修改成功, 更新表格
                    this.initUserData()
                    this.$message.success('修改成功')
                    this.editDialogVisible = false
                } else {
                    this.$message.error('修改失败')
                }
            })
        },
        // 展示编辑用户的对话框
        showEditDialog(id, name, description, price, discount, type, projectName, produceCount, state, additionalConfig, row) {
            this.editForm.id = id;
            this.editForm.name = name;
            this.editForm.description = description;
            this.editForm.price = price;
            this.editForm.discount = discount;
            this.editForm.type = type;
            this.editForm.projectName = projectName;
            this.editForm.produceCount = produceCount;
            this.editForm.state = state;
            this.additionalConfig = additionalConfig;
            this.editForm.additionalConfig = additionalConfig
            this.editForm.loginLimit = row.loginLimit;
            this.editForm.productOrder = row.productOrder;
            this.editForm.productId = row.productId;
            
            this.productChannels = [];
            this.productChannelInputVisible = false;
            this.productInputChannel = undefined;
            if (row.channels) {
                this.productChannels = JSON.parse(row.channels);
            }
            this.editForm.limitBuyStatus = row.limitBuyStatus;
            this.editForm.limitCount = row.limitCount;
            this.editForm.metadata = row.metadata
            this.editForm.purchaseCooldownPeriod = row.purchaseCooldownPeriod
            this.editForm.purchaseCooldownPeriodType = row.purchaseCooldownPeriodType
            
            if (!this.editForm.purchaseCooldownPeriodType) {
                this.editForm.purchaseCooldownPeriodType = 'PERMANENT'
            }
            if (!this.editForm.purchaseCooldownPeriod) {
                this.editForm.purchaseCooldownPeriod = 1
            }
            
            this.editDialogVisible = true;
        },
        //下拉框名称信息
        getProjectName() {
            queryProjectInfoList({pageSize: 10000}).then(result => {
                if (result.code === 200) {
                    this.projects = result.data.result
                }
            })
        },
        //下拉框动作
        current() {
            this.getDeviceInfoData(1, this.query.projectName)
        },
        //项目名称信息
        getDeviceInfoData(pageNum, projectName) {
            // 参数
            if (pageNum == undefined || pageNum == '') pageNum = 1
            if (projectName == undefined || projectName == '') projectName = 'NULL'
            // 发送请求
            let params = {
                'projectName': this.query.projectName,
                'startPage': this.user.pageIndex,
                'pageCount': this.user.pageSize,
                channel: this.query.channel,
                productId: this.query.productId
            };
            selProduce(params).then(res => {
                if (res.status == 200) {
                    this.user.tableData = res.data.data.records;
                    this.user.pageTotal = res.data.data.total;
                }
                this.user.loading = false
            }).catch(err => {
                this.user.loading = false
            })

        },

        //初始化数据
        initUserData() {
            this.user.loading = true
            //如果搜索框不等于 空, 添加搜索条件
            let noticeId = ''
            if (this.query.noticeSearch != '' && this.query.noticeSearch != undefined) {
                noticeId = this.query.noticeSearch
            }
            //发送请求
            let params = {
                'startPage': this.user.pageIndex,
                'pageCount': this.user.pageSize,
                projectName: this.query.projectName
            };
            selProduce(params).then(res => {
                if (res.status == 200) {
                    this.user.tableData = res.data.data.records
                    this.user.pageTotal = res.data.data.total;
                }
                this.user.loading = false
            }).catch(err => {
                this.user.loading = false
            })
        },

        //row点击  进入编辑页
        rowNoticeClick(row, column) {
            if (column.label != '内容') return
            this.$router.push({
                path: `/Notice/${row.id}`
            })
        },

        //搜索框
        handleUserSearch() {
            this.initUserData()
        },

        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },

        //上一页 or 下一页
        handleUserPageChange(pageIndex) {
            this.user.pageIndex = pageIndex
            this.initUserData()
        },
        handleSizeChange(size) {
            this.user.pageSize = size;
            this.user.pageIndex = 1;
            this.initUserData();
        },
        handleSubmitConfig(value) {
            console.log(value);
            if (value) {
                this.editForm.additionalConfig = JSON.stringify(value);
            } else {
                this.editForm.additionalConfig = null;
            }
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            if (row.state !== 0) {
                message.error('请先下架该商品');
                return;
            }
            this.$modal.confirm('是否确认删除"' + row.name + '"商品？').then(function() {
                return productApi.deleteData(row.id);
            }).then((result) => {
                if (result.code === 200) {
                    this.initUserData();
                    this.$modal.msgSuccess('删除成功');
                }
            }).catch(() => {
            });
        },
        resetQuery() {
            this.initUserData();
        },
        
        
        handleClose(tag) {
            this.productChannels.splice(this.productChannels.indexOf(tag), 1);
        },
        
        showInput() {
            this.productChannelInputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        
        handleInputConfirm() {
            let inputValue = this.productInputChannel;
            if (!inputValue) {
                return;
            }
            const channelList = inputValue.split(' ');
            channelList.forEach(channel => {
                if (this.productChannels.indexOf(channel) !== -1) {
                    message.error(`渠道${channel}已存在`);
                return;
                }
                if (channel) {
                    this.productChannels.push(channel);
                }
            })

            this.productChannelInputVisible = false;
            this.productInputChannel = '';
        },
        
        updateProductOrder(row) {
            modifyProduce(JSON.stringify(row)).then(res => {
                if (res.status === 200) {
                    // 修改成功, 更新表格
                    this.initUserData();
                    this.$message.success('修改成功');
                } else {
                    this.$message.error('修改失败');
                }
            });
        },
        handleCloseEditDialog() {
            this.editDialogVisible = false;
            this.additionalConfig = '{}';
        }
    }
}
</script>

<style scoped lang="scss">


/* 鼠标悬浮 */
::v-deep.el-table--enable-row-hover .el-table__body tr:hover>td {
    //  background-color: #212e3e !important;
    cursor: pointer;
}

.handle-input {
    width: 260px;
    display: inline-block;
    margin-right: 10px;
}
</style>
